// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__23mv5","list":"BalanceDue_list__Ac_tO","listRow":"BalanceDue_listRow__RcstV","total":"BalanceDue_total__2D3Cp"};